import React from 'react'
import styled from "styled-components";

const SubTextBold=styled.h3`
font-weight:bold;
padding:"0px 10px";
text-align:center;
margin:0;
justify-self:center;
font-size:20px;

@media screen and (max-width:375px)
{
    font-size:17px;
}
`;

const Link=styled.a`
padding:"0px 10px";
text-align:center;
margin:5px;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}
`;

const SubText=styled.h3`
padding:"0px 10px";
text-align:center;
margin:0;
margin-top:15px;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}
`;


const Horarios = () => 
{
    return <>
    <SubText>⚠️Horarios</SubText>

    <SubText>Viernes, Sábados y vísperas</SubText>
    <SubText>de 12:00 a 3:30 hs.</SubText>
    <SubText>[Cocina cierra 1:30 y barra 3:00hs]</SubText>
    <SubText>Domingos a Jueves y feriados</SubText>
    <SubText>de 12:00 a 2:00 hs.</SubText>
    <SubText>[Cocina cierra 0:30 y barra 1:15hs]</SubText>
    {/* <SubText><b>-Todos los dias de 12 a 23hs</b></SubText>
    <SubText>Bar: <a href="https://baumlanus.com.ar" target="_blank">baumlanus.com.ar</a></SubText>
    <SubText>Delivery y Takeaway: <a href="https://delivery.baumlanus.com.ar" target="_blank">delivery.baumlanus.com.ar</a></SubText>
    <SubText>Pedidos Ya: <a href="https://baumlanus.com.ar/pedidosya" target="_blank">baumlanus.com.ar/pedidosya</a></SubText> */}
    </>
}

export default Horarios

